/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Speed_LabelInputs */



/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Event_Ad_Speed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_speed_label = /** @type {((inputs?: Event_Ad_Speed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Speed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tempo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скорость")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("播放速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade")
	return /** @type {LocalizedString} */ ("Speed")
});